export default "__VITE_ASSET__wG0Am3PoLp$6Qj4KrWO8_A__"